// Client-side mirror of server/utils/instagramUrl.js, so a mistyped link is
// flagged while the admin is still looking at it. The server re-validates.

const POST_PATH = /(?:^|\/)(p|reel|reels|tv)\/([A-Za-z0-9_-]{5,})(?:\/|$)/;

export function parseInstagramUrl(input) {
  const raw = String(input || '').trim();
  if (!raw) return null;

  let url;
  try {
    url = new URL(raw.includes('://') ? raw : `https://${raw}`);
  } catch {
    return null;
  }

  const host = url.hostname.toLowerCase().replace(/^www\./, '');
  if (host !== 'instagram.com' && host !== 'instagr.am') return null;

  const match = url.pathname.match(POST_PATH);
  if (!match) return null;

  const kind = match[1] === 'reels' ? 'reel' : match[1];
  return {
    kind,
    shortcode: match[2],
    url: `https://www.instagram.com/${kind}/${match[2]}/`,
  };
}
